import {
  DeliveryTypeEnum,
  OrderEventsEnum,
  SmopOrderStatusEnum
} from "@saleor/types/globalTypes";
import Moment from "moment";

export const onTimeIsTrue = data => (data ? "YES" : "NO");

export const secondsToHms = d => {
  d = Number(d);
  const h = Math.floor(d / 3600);
  const m = Math.floor((d % 3600) / 60);
  const s = Math.floor((d % 3600) % 60);

  const hDisplay = h > 0 ? h + (h === 1 ? " hour " : " hours") : "";
  const mDisplay = m > 0 ? m + (m === 1 ? " minute " : " minutes ") : "";
  const sDisplay = s > 0 ? s + (s === 1 ? " second" : " seconds") : "";

  if (hDisplay) {
    return hDisplay;
  } else if (mDisplay && !hDisplay) {
    return mDisplay;
  } else if (sDisplay && !mDisplay) {
    return sDisplay;
  }
  //   return hDisplay + mDisplay + sDisplay;
};

export const isExpressDelivery = (deliveryType: DeliveryTypeEnum) =>
  [
    DeliveryTypeEnum.EXPRESS,
    DeliveryTypeEnum.EXPRESS_LONG_DISTANCE,
    DeliveryTypeEnum.SAME_DAY
  ].includes(deliveryType);

export function InvalidThreeMonth(dateFrom, dateTo) {
  // check if order date range is invalid and not greater than 3 months
  if (
    Moment(dateFrom).isAfter(dateTo) ||
    Moment(dateTo).diff(dateFrom, "days") > 90
  ) {
    return true;
  } else {
    return false;
  }
}

export const isStandardDeliveryNewRTS = (
  deliveryType: DeliveryTypeEnum,
  smopStatus: SmopOrderStatusEnum
) =>
  [DeliveryTypeEnum.NEXT_DAY].includes(deliveryType) &&
  [SmopOrderStatusEnum.NEW_ORDER, SmopOrderStatusEnum.READY_TO_SHIP].includes(
    smopStatus
  );

export const isStandardDelivery = (deliveryType: DeliveryTypeEnum) =>
  [DeliveryTypeEnum.NEXT_DAY].includes(deliveryType);

export const isNationwideRTS = (
  deliveryType: DeliveryTypeEnum,
  status: SmopOrderStatusEnum
) =>
  deliveryType === DeliveryTypeEnum.NATIONWIDE_DELIVERY &&
  status === SmopOrderStatusEnum.READY_TO_SHIP;

export const failedReasonsNationwideDelivery = (failedReason: string) =>
  failedReason?.includes("INVALID BOX") ||
  failedReason === "AWB ALREADY USED" ||
  failedReason === "Service Unavailable";

export const disableDimWeightNationwide = (failedReason: string) =>
  failedReason === "AWB ALREADY USED" || failedReason === "Service Unavailable";

export const isNationwideDelivery = (deliveryType: string): boolean =>
  deliveryType === "NATIONWIDE_DELIVERY";

export const isNationwideOrderEvents = (
  deliveryType: DeliveryTypeEnum,
  orderEvents: OrderEventsEnum
) =>
  [DeliveryTypeEnum.NATIONWIDE_DELIVERY].includes(deliveryType) &&
  [
    OrderEventsEnum.ORDER_RETURNED_TO_FC,
    OrderEventsEnum.ORDER_MARKED_AS_PICKED_UP_BY_COURIER,
    OrderEventsEnum.ORDER_MARKED_AS_RECEIVED_BY_COURIER,
    OrderEventsEnum.ORDER_2GO_BOOKING_SUCCESS
  ].includes(orderEvents);

export const LAST_RIDER_ASSIGNED_AT = "lastRiderAssignedAt";

export const ASSIGNMENT_COOLDOWN_SECONDS = 40;
